import { render, staticRenderFns } from "./SetNew.vue?vue&type=template&id=5418d87e"
import script from "./SetNew.vue?vue&type=script&lang=js"
export * from "./SetNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports